import React from "react";
import UserTicketsComp from "../../components/portal/UserTickets";

const UserTickets = () => {
  return (
    <div className="container mx-auto px-4">
      <h1 className="text-3xl font-bold">My Tickets</h1>
      <p className="max-w-2xl mt-2 text-md text-gray-500 mb-6">
        See all your WattleNest Event tickets listed here.
      </p>
      <UserTicketsComp />
    </div>
  );
};

export default UserTickets;
